import {
  addLocalStorage,
  getLocalStorage, removeLocalStorage
} from '../../../infra/storage/localStorage'

export const getFarmIri = () => {
  const user = getLocalStorage('farm')
  if (user) {
    const data = JSON.parse(user)
    return `/farm/${data.id}`
  }

  return null
}

export const getFarm = () => {
  const farm = getLocalStorage('farm')
  return JSON.parse(farm) || null
}

export const setFarm = async (farm) => {
  await addLocalStorage('farm', JSON.stringify(farm))
}

export const removeFarm = () => {
  removeLocalStorage('farm')
}
